import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const AddressSearchInput = ({ onSearch }) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");

  // this useEffects are for waiting 2 seconds after user stops writing
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 2000);

    return () => clearTimeout(handler);
  }, [inputValue]);

  useEffect(() => {
    if (!debouncedValue.trim()) return;
    onSearch(debouncedValue);
  }, [debouncedValue]);

  return (
    <input
      type="text"
      className="floating-label-field floating-label-field--s1"
      style={{
        padding: "0 0.5em",
        marginRight: "20px",
        marginLeft: "20px",
        width: "95%",
      }}
      id="address_for_branch_search"
      placeholder={t("information.address_for_branch_search")}
      onChange={(e) => setInputValue(e.target.value)}
      value={inputValue}
    />
  );
};

export default AddressSearchInput;
